module.exports = "<input type=\"number\" min=\"0\" max=\"10\" step=\"2\" placeholder=\"Number of whatever\">";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader?interpolate!./src/components/input-number/sample.html
// module id = 71
// module chunks = 0